import { readonly, ref } from 'vue';

export interface ConfirmationOptions {
	header?: string;
	message?: string;
	icon?: string | [string, string];
	acceptLabel?: string;
	rejectLabel?: string;
	acceptClass?: string;
	rejectClass?: string;
	acceptProps?: Record<string, unknown>;
	rejectProps?: Record<string, unknown>;
	accept?: () => void | Promise<void>;
	reject?: () => void | Promise<void>;
	onShow?: () => void;
	onHide?: () => void;
}

const activeConfirmation = ref<ConfirmationOptions | null>(null);

function requireConfirmation(options: ConfirmationOptions): void {
	activeConfirmation.value = options;
	options.onShow?.();
}

function close(): void {
	const current = activeConfirmation.value;
	activeConfirmation.value = null;
	current?.onHide?.();
}

async function accept(): Promise<void> {
	const current = activeConfirmation.value;
	close();
	await current?.accept?.();
}

async function reject(): Promise<void> {
	const current = activeConfirmation.value;
	close();
	await current?.reject?.();
}

export const confirmationState = readonly(activeConfirmation);

export function useConfirm() {
	return { require: requireConfirmation, close };
}

export const confirmationActions = { accept, reject, close };
